import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Plus } from 'lucide-react';
import { useIntl } from 'react-intl';

import {
  apiPostStoryQuestion,
  APIPostStoryQuestionPayload,
  StoryQuestion,
} from '@/shared/api';
import { storyByIdQueryOptions } from '@/shared/queries';
import { Button } from '@/shared/ui/button';

type AddNewStoryQuestionProps = {
  categoryId: string;
  storyId: string;
};

export const AddNewStoryQuestion = ({
  categoryId,
  storyId,
}: AddNewStoryQuestionProps) => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  const mutation = useMutation<StoryQuestion, Error, APIPostStoryQuestionPayload>({
    mutationFn: (payload) => {
      return apiPostStoryQuestion(payload).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: storyByIdQueryOptions(storyId).queryKey,
      });
    },
  });

  return (
    <Button onClick={() => mutation.mutate({ categoryId: String(categoryId) })}>
      <Plus /> {intl.formatMessage({ id: 'button.addNewQuestion' })}
    </Button>
  );
};
